/**
 * Токены экзаменационного скина.
 *
 * Эталон — docs/exam-skin-reference/ai_studio_code.html (выбран владельцем
 * продукта 29.08.2026). Оттуда взята вся внешность: палитра, типографика,
 * отступы, иконки. Замеры Coursology в той же папке оставлены для сверки
 * поведения (жёлоб под иконки появляется только после ответа), но цвета
 * и кегли идут из файла.
 *
 * Ширины колонок не фиксируем, кроме навигации: раскладка адаптивная.
 */
export const T = {
    color: {
        /* Служебные панели */
        bar: '#2A4D87',
        barLine: '#1F3B68',
        barHover: '#395E9F',
        barText: '#FFFFFF',
        barMuted: '#DBEAFE',      // blue-100 — подпись под номером вопроса

        /* Колонка навигации — эталон ai_studio_code-2.html.
           Разделителей нет: строки различаются зеброй. */
        navZebraOdd: '#E9ECF2',
        navZebraEven: '#FFFFFF',
        navHover: '#DCE1EA',
        navCurrent: '#DCE1EA',    // своего состояния в эталоне нет — берём его же ховер
        navBorder: '#D9DFE7',
        navNumber: '#242F3E',
        /* Иконки статуса в колонке — свои, ярче общих */
        navCorrect: '#76B800',
        navIncorrect: '#E04A44',

        /* Рабочее поле */
        page: '#FFFFFF',
        surface: '#FFFFFF',
        text: '#1E293B',          // slate-800 — базовый
        textStrong: '#000000',    // виньетка и варианты
        muted: '#334155',         // slate-700 — проценты
        hint: '#64748B',          // slate-500 — подписи в шапке разбора
        line: '#CBD5E1',

        /* Акцент — он же рамка карточки вариантов и ссылки */
        accent: '#2A75D3',
        cardBorder: '#2A75D3',

        /* Кружок выбора */
        radioBorder: '#94A3B8',   // slate-400
        radioBg: '#F1F5F9',       // slate-100
        radioSelBorder: '#2563EB',// blue-600
        radioSelBg: '#DBEAFE',    // blue-100

        /* Состояния */
        correct: '#16A34A',       // green-600
        incorrect: '#EF4444',     // red-500
        correctBorder: '#4ADE80', // green-400 — рамка баннера
        incorrectBorder: '#F87171',
        correctText: '#16A34A',
        incorrectText: '#DC2626', // red-600

        highlight: '#FEF08A',
    },
    /** База при коэффициенте 1. Кегли — из эталона. */
    type: {
        stem: { size: 15, line: 24 },
        option: { size: 14.5, line: 23 },
        nav: { size: 20, line: 20 },
        bar: { size: 13, line: 17 },
        barSub: { size: 11, line: 14 },
        tool: { size: 10, line: 13 },
        small: { size: 12, line: 16 },
        banner: { size: 18, line: 24 },
    },
    layout: {
        navWidth: 76,
        navRow: 38,
        navRowPadding: '0 16px 0 14px',
        navIcon: 18,
        topBar: 'auto',
        barPaddingTop: '6px 12px',
        barPaddingBottom: '8px 16px',
        contentPad: 28,
        sectionGap: 24,

        /** Жёлоб слева появляется ТОЛЬКО после ответа — под иконки результата. */
        gutter: 16,
        optionGap: 14,
        radio: 20,
        radioDot: 10,

        cardPadding: 16,
        cardRadius: 2,

        bannerPadding: 16,
        bannerRadius: 8,

        toolGap: 16,
    },
    /** Эталон набран системным гротеском, не Inter. */
    font: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
};

export const FONT_SCALE_KEY = 'apex_exam_font_scale';
export const FONT_SCALE_STEPS = [0.9, 1, 1.15, 1.3, 1.5];

/** Кегль контента — с учётом пользовательского коэффициента. */
export const fs = (metric, scale) => ({
    fontSize: `${Math.round(metric.size * scale * 10) / 10}px`,
    lineHeight: `${Math.round(metric.line * scale * 10) / 10}px`,
});

/** Кегль служебных панелей — БЕЗ коэффициента: на экзамене они не масштабируются. */
export const fx = (metric) => ({
    fontSize: `${metric.size}px`,
    lineHeight: `${metric.line}px`,
});
